"use client";

import { useContext, useEffect, useState } from 'react';
import './../Industry/index.scss';
import TypoGraphy from '@/typography';
import { projectStrings } from '@/utils/projectstrings';
import useViewType from '@/utils/Hooks/useViewType';
import CardSection from '@/reusablecomponents/CardSection';
import NextStep from '@/elements/NextStep';
import FaqSection from '@/reusablecomponents/FaqSection';
import Pagination from '@/reusablecomponents/Pagination';
import { useParams, useRouter } from 'next/navigation';
import { getSlugAndRouteName } from '@/utils/Functions';
import { AppContext } from '@/contexts/appcontext';
import eventTracker from '@/utils/eventTracker';
import { RouteStrings } from '@/utils/routestrings';
import TestimonialsSection from '@/reusablecomponents/TestimonialsSection';
import QuestionsSection from '@/components/freecourses/QuestionsSection';
import { API_ENDPOINTS } from '@/services/endPoints';
import { apiService } from '@/services/apiService';
import * as Sentry from "@sentry/nextjs";
const SubIndustryPage = ({
  industryData,
  testimonials,
  mainIndustryData,
  indusData,
  currentSubIndustry,
  faqs,
  filteredSubIndustries
}: any) => {
  const {
    push
  } = useRouter();
  if (!mainIndustryData?.data?.length) {
    push("/notfound");
  }
  const [pageNo, setPageNo] = useState<number>(1);
  const isMobile = useViewType(800);
  const params = useParams();
  const {
    isSubIndustry
  } = getSlugAndRouteName(params?.route?.toString() || '');
  const [touched, settouched] = useState(false);
  const [industryDetail, setindustryDetail] = useState(industryData);
  let pageCounter: number = industryDetail?.meta.pagination.pageCount;
  const {
    setIndustry,
    updateSchemaData,
    showIndustryContent,
    settitle,
    setdescription,
    isBeginner,
    isIntermediate,
    isAdvanced
  } = useContext<any>(AppContext);
  useEffect(() => {
    eventTracker.freeCoursePageViewed({
      pageName: `${currentSubIndustry} Sub-Industry Page`
    });
  }, [currentSubIndustry]);
  const [filterText, setfilterText] = useState(isSubIndustry ? currentSubIndustry.replace("-", " ") : 'All');
  const [activefilter, setActiveFilter] = useState<any>(isSubIndustry ? currentSubIndustry.replace("-", " ") : 'All');
  const handleFilterClick = (text: string, index?: number, id?: number) => {
    if (isSubIndustry && id) {
      push(RouteStrings.DYNAMICROUTE(text.replaceAll(' ', '-'), 'SUBINDUSTRY', id));
    }
    setfilterText(text);
    if (typeof index === 'number') setActiveFilter(index);else setActiveFilter("All");
  };
  useEffect(() => {
    document.title = `Free ${currentSubIndustry?.replace("-", " ")} Online Certificate Courses | Growthschool`;
    settitle(`Upskill & Build a Career in ${currentSubIndustry} with Free Online Certificate Courses`);
    setdescription(projectStrings.upskillSubheading);
  }, []);
  const handlePageChange = (page: number) => {
    setPageNo(page);
    if (!touched) {
      settouched(true);
    }
  };
  useEffect(() => {
    try {
      if (isSubIndustry) {
        setActiveFilter(currentSubIndustry.replaceAll('-', " "));
        setfilterText(currentSubIndustry.replaceAll('-', " "));
      }
      if (!touched) return;
      apiService(API_ENDPOINTS.APP_SERVER_URL + API_ENDPOINTS.subIndustryPageData(currentSubIndustry ?? '', pageNo), true, {}, 5000).then((resp: any) => resp.json()).then((data: any) => setindustryDetail(data)).catch((error: any) => {
        console.error("Error fetching sub-industry data:", error);
        Sentry.captureException(error);
      });
    } catch (error) {
      Sentry.captureException(error);
      console.error("Error occurred in SubIndustryPage:", error);
    }
  }, [pageNo]);
  useEffect(() => {
    if (indusData?.data?.length > 0) {
      const [card] = indusData?.data;
      setIndustry(card?.attributes?.primaryIndustry?.data?.attributes?.industryName ?? card?.attributes?.industries?.data[0]?.attributes?.industryName);
    }
  }, [indusData]);
  return <div className="industry_page_wrapper" data-sentry-component="SubIndustryPage" data-sentry-source-file="index.tsx">
      <div className="industry_top_section">
        <div className='industry_heading_wrapper'>
          <div className="title_wrapper"> <TypoGraphy text={`Upskill & Build a Career in ${currentSubIndustry} with Free Online Certificate Courses`} variant={isMobile ? 'Mobile/Heading' : 'Desktop/Heading 2'} tagName='h1' data-sentry-element="TypoGraphy" data-sentry-source-file="index.tsx" />
          </div>
          <div className="sub_title_wrapper"> <TypoGraphy text={projectStrings.upskillSubheading} variant={isMobile ? 'Mobile/Body 1' : 'Desktop/Heading 1'} tagName='p' data-sentry-element="TypoGraphy" data-sentry-source-file="index.tsx" /></div></div>
        {isMobile && <div className="industry_filters">
            {filteredSubIndustries.map((element: any, index: number) => {
          return <a href={RouteStrings.DYNAMICROUTE(element?.attributes?.subIndustry, 'SUBINDUSTRY', element?.id)} className={element?.attributes?.subIndustry === filterText ? "filter filter_active" : "filter"} onClick={(e: any) => {
            e.preventDefault();
            handleFilterClick(element?.attributes?.subIndustry, index, element?.id);
          }} key={`filter-${index}`} title={`Free ${element?.attributes?.subIndustry} Courses`}>
                <TypoGraphy text={element?.attributes?.subIndustry} variant='Desktop/Body 2/R | 14 |120' />
              </a>;
        })}
          </div>}
      </div>
      <div className="industry_card_content_wrapper">
        <CardSection data={{
        cards: industryDetail?.data,
        filters: filteredSubIndustries
      }} title='' isFilterArray currentSubIndustry={currentSubIndustry} subIndustryName={currentSubIndustry} data-sentry-element="CardSection" data-sentry-source-file="index.tsx" />
      </div>
      {showIndustryContent && !(isBeginner || isIntermediate || isAdvanced) && <div className="industry_pagination_wrapper">
        <Pagination pageCount={pageCounter} pageNo={pageNo} onPageChange={handlePageChange} />
      </div>}
      <TestimonialsSection data={testimonials} title={projectStrings.learners} type={'TESTIMONIAL'} data-sentry-element="TestimonialsSection" data-sentry-source-file="index.tsx" />
      <div className="" style={{
      paddingBottom: !isMobile ? "40px" : ""
    }}>
        <NextStep data-sentry-element="NextStep" data-sentry-source-file="index.tsx" />
      </div>
      <QuestionsSection data-sentry-element="QuestionsSection" data-sentry-source-file="index.tsx" />
      {faqs?.length && <FaqSection data={faqs} isSectional />}
    </div>;
};
export default SubIndustryPage;